export const formatMobilePhone = value => value && value.startsWith('+7 ')
  ? value.substring(3)
  : value;
